var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { selectSurface } from "./selectors/selectSurface";
import { parseMM } from "./utils/unitHelper";
export function determinePixelSizeByDimension(_a) {
  return __awaiter(this, arguments, void 0, function (_ref) {
    let {
      dimension,
      selector,
      cimDoc
    } = _ref;
    return function* () {
      const surface = yield selectSurface({
        selector,
        document: cimDoc
      });
      const surfaceWidth = parseMM(surface.width);
      const surfaceHeight = parseMM(surface.height);
      return "".concat(Math.max(surfaceWidth, surfaceHeight) / dimension, "mm");
    }();
  });
}
export function determinePixelSizeByWidth(_a) {
  return __awaiter(this, arguments, void 0, function (_ref2) {
    let {
      width,
      selector,
      cimDoc
    } = _ref2;
    return function* () {
      const surface = yield selectSurface({
        selector,
        document: cimDoc
      });
      const surfaceWidth = parseMM(surface.width);
      return "".concat(surfaceWidth / width, "mm");
    }();
  });
}
export function determinePixelSizeByHeight(_a) {
  return __awaiter(this, arguments, void 0, function (_ref3) {
    let {
      height,
      selector,
      cimDoc
    } = _ref3;
    return function* () {
      const surface = yield selectSurface({
        selector,
        document: cimDoc
      });
      const surfaceHeight = parseMM(surface.height);
      return "".concat(surfaceHeight / height, "mm");
    }();
  });
}